/* ============================================================================
   Storage that never throws. A full localStorage (Safari's 5 MB), a blocked
   one (some private modes and in-app webviews) or a corrupt one used to throw
   from inside an effect or a click handler — and an exception in an effect
   blanks the page. Writes that cannot be kept are dropped with one warning;
   reads that fail read as "nothing saved". Imported first, before any store.
   ========================================================================== */
let warned = false;
try {
  if (typeof Storage !== "undefined") {
    const proto = Storage.prototype;
    const set = proto.setItem, get = proto.getItem, remove = proto.removeItem;
    proto.setItem = function (k: string, v: string) {
      try { set.call(this, k, v); }
      catch (e) { if (!warned) { warned = true; console.warn("Browser storage is full or blocked — this device will not remember", k, e); } }
    };
    proto.getItem = function (k: string) { try { return get.call(this, k); } catch { return null; } };
    proto.removeItem = function (k: string) { try { remove.call(this, k); } catch { /* blocked */ } };
  }
} catch { /* very old engine — leave storage as it is */ }
export {};
